import * as React from "react";
import IconButtonMain from "../../../UIcomponentsRedesign/IconButtonMain/IconButtonMain";
import { COLORS } from "../../../core/consts/redesign/commonRedesign";
import { Close, Docs, Img, Refresh } from "../../../core/consts/redesign/icons";
import { isImageFile } from "../../../core/helpers/isImageFile";
import { LoadingLeadDocInnerType } from "../../../core/types/leadsApiTypes";
import { UploadingLeadDocExampleType } from "../../../core/types/partnerApiTypes";
import { useStyles } from "./DocPreviewStyles";

type IProps = {
  file: LoadingLeadDocInnerType | UploadingLeadDocExampleType;
  handleDocClick?: () => void;
  handleCancel: () => void
  handleRestart?: () => void;
};

const DocPreviewUploading: React.FC<IProps> = ({
  file,
  handleDocClick,
  handleCancel,
  handleRestart
}) => {
  const classes = useStyles();
  const fileId = file.id;
  const fileName = file.name ?? '';

  return (
    <>
      <div id={fileId.toString()}
        className={classes.container}
        style={{ justifyContent: 'space-between' }}
        onClick={handleDocClick}>
        {isImageFile(fileName) ?
          <Img color={COLORS.gray2} /> :
          <Docs color={COLORS.gray2} />
        }
        <div className={classes.desc}>
          <span className={classes.docTitle}>{file.name}</span>
          <div className={classes.sizeBox}>
            <span className={classes.docSize}>{`${file.loadedMB} из ${file.totalMB} мб`}</span>
            {file.error && <span className={classes.errorText}>{file.error}</span>}
          </div>
        </div>
        {file.error ?
          <IconButtonMain
            title="Загрузить еще раз"
            className={classes.removeButton}
            color='noBgGray'
            aria-label="close"
            icon={<Refresh />}
            handleClick={handleRestart} />
          :
          <IconButtonMain
            title="Прервать загрузку"
            className={classes.removeButton}
            color='noBgGray'
            style={{ padding: '3px' }}
            aria-label="close"
            icon={<Close />}
            handleClick={handleCancel} />
        }
      </div>
      <div className={classes.progressBar}>
        <div
          className={`${classes.progress} ${file.error ? classes.progressYellow : classes.progressGreen}`}
          style={{ width: `${file.progress}%` }}
        />
      </div>
    </>
  );
};

export default DocPreviewUploading;